import { Status, TableColumn } from "../types";

export const openStatuses: Status[] = [
  {
    legend: "ADA",
    id: "awaiting_driver_allocation",
    name: "Awaiting Driver Allocation",
    color: "#F86262",
    icon: "circle",
  },
  {
    legend: "ADC",
    id: "driver_allocated_not_confirmed",
    name: "Awaiting Driver Confirmation",
    color: "#FEBC58",
    icon: "circle",
  },
  {
    legend: "ALC",
    id: "driver_allocated_confirmed",
    name: "Driver Allocated Confirmed",
    color: "#88D79A",
    icon: "circle",
  },
  {
    legend: "DOW",
    id: "on_way_to_job",
    name: "Driver On The Way",
    color: "#8DAD95",
    icon: "circle",
  },
  {
    legend: "COM",
    id: "commenced",
    name: "Commenced",
    color: "#78B4FC",
    icon: "circle",
  },
];

export const closedStatuses: Status[] = [
  {
    legend: "CRV",
    id: "complete_awaiting_review",
    name: "Complete Awaiting Review",
    color: "#FDF07B",
    icon: "circle",
  },
  {
    legend: "CSD",
    id: "closed",
    name: "Closed",
    color: "#D1D2D5",
    icon: "circle",
    tooltip: "Closed",
  },
  {
    legend: "CND",
    id: "cancelled",
    name: "Cancelled",
    color: "#F04438",
    icon: "close",
  },
];

export const allStatuses = [...openStatuses, ...closedStatuses];

export const statusMapping = allStatuses.reduce((acc, curr) => {
  acc[curr.id] = curr;
  return acc;
}, {} as Record<string, Status>);

const remainingScreenWidth = document.documentElement.clientWidth - 1500;

export const allColumns: TableColumn[] = [
  {
    id: "offloadIcon",
    header: "",
    size: 32,
    isJSX: true,
    isDefault: true,
    isFixed: true,
    isVisibleMobile: true,
    isSortDisabled: true,
  },
  {
    id: "id",
    header: "ID",
    sortId: "job_id",
    isJSX: true,
    isDefault: true,
    size: 125,
    isFixed: true,
    isVisibleMobile: true,
  },
  {
    id: "status",
    header: "Status",
    isJSX: true,
    isDefault: true,
    isVisibleMobile: true,
    size: 125,
  },
  {
    id: "date",
    header: "Date",
    isDefault: true,
    isJSX: true,
    isVisibleMobile: true,
    size: 100,
  },
  {
    id: "dateAndTime",
    header: "Date and Time",
    isJSX: true,
    isSortDisabled: true,
    isVisibleMobile: true,
    size: 200,
  },
  {
    id: "time",
    header: "Time",
    size: 100,
    isDefault: true,
    isJSX: true,
    isVisibleMobile: true,
  },
  {
    id: "passenger",
    header: "Passenger",
    size: 150,
    isDefault: true,
    isJSX: true,
    isVisibleMobile: true,
  },
  {
    id: "pickupLocationFull",
    sortId: "pickup",
    // header: "Pick-up Location (Full)",
    header: "Pick-up Location",
    isDefault: true,
    isVisibleMobile: true,
    size: Math.max(200, remainingScreenWidth / 2),
  },
  // {
  //   id: "pickupLocationSuburb",
  //   sortId: "pickup",
  //   header: "Pick-up Location (Suburb)",
  //   isVisibleMobile: true,
  //   size: Math.max(200, remainingScreenWidth / 2),
  // },
  {
    id: "destinationFull",
    // header: "Destination (Full)",
    header: "Destination",
    sortId: "destination",
    isDefault: true,
    isVisibleMobile: true,
    size: Math.max(200, remainingScreenWidth / 2),
  },
  // {
  //   id: "destinationSuburb",
  //   header: "Destination (Suburb)",
  //   isVisibleMobile: true,
  //   size: Math.max(200, remainingScreenWidth / 2),
  // },
  {
    id: "driver",
    header: "Driver",
    size: 150,
    isDefault: true,
    isJSX: true,
    isVisibleMobile: true,
  },
  {
    id: "cost",
    header: "Cost",
    isDefault: true,
    size: 100,
  },
  {
    id: "paymentStatus",
    header: "Payment Status",
    sortId: "payment_status",
    isJSX: true,
    isDefault: true,
    size: 175,
  },
  {
    id: "client",
    header: "Client",
    size: 150,
    sortId: "client_name",
    isDefault: false,
  },
  {
    id: "bookedBy",
    size: 150,
    header: "Booked by",
    sortId: "booked_by",
    isDefault: false,
  },
  {
    id: "company",
    header: "Company",
    isDefault: false,
    size: 150,
  },
  {
    id: "vehicleType",
    header: "Vehicle Type",
    sortId: "vehicle_type",
    isDefault: false,
    size: 150,
  },
  {
    id: "transferType",
    header: "Transfer Type",
    sortId: "transfer_type",
    isDefault: false,
    size: 150,
  },
  {
    id: "operator",
    header: "Operator",
    isSortDisabled: true,
    isDefault: false,
    size: 200,
  },
  {
    id: "paymentMethod",
    header: "Payment Method",
    isSortDisabled: true,
    isDefault: false,
    size: 150,
  },
  {
    id: "dashboardNotes",
    header: "Dashboard Notes",
    isSortDisabled: true,
    isDefault: false,
    size: 200,
  },
];

export const paymentStatuses = {
  prepaid_partial: "Partially Paid",
  prepaid: "Pre-Paid",
  pending: "Pending",
  paid: "Paid",
  no_charge: "No Charge",
  refunded: "Refunded",
  refund_in_progress: "Refund in Progress",
  refund_failed: "Refund Failed",
  refunded_partial: "Partially Refunded",
  invoice_pending: "Invoice Pending",
  invoice_ready: "Invoice Ready",
  invoiced: "Invoiced",
  invoiced_paid: "Invoice Paid",
};

export const paymentMethods = {
  credit_card: "Credit Card",
  invoice: "Invoice",
};

export const offloadOptions = [
  { id: "all", name: "All" },
  { id: "offloaded-to-network", name: "Offloaded to Network" },
  {
    id: "accepted-from-network",
    name: "Accepted from Network",
  },
];
